import JsBarcode from 'jsbarcode';

const DEFAULT_SERVICE = '0000ffe0-0000-1000-8000-00805f9b34fb';
const DEFAULT_CHARACTERISTIC = '0000ffe1-0000-1000-8000-00805f9b34fb';
let device = null;
let characteristic = null;

export function printerConnected() {
  return !!(device && device.gatt && device.gatt.connected && characteristic);
}

export function printerProfile() {
  try {
    return JSON.parse(localStorage.getItem('onlinePackingPrinter') || '{}');
  } catch (e) { return {}; }
}

export async function connectPrinter(service = DEFAULT_SERVICE, writer = DEFAULT_CHARACTERISTIC) {
  if (!navigator.bluetooth) throw new Error('مرورگر این گوشی از Web Bluetooth پشتیبانی نمی‌کند.');
  service = service || DEFAULT_SERVICE;
  writer = writer || DEFAULT_CHARACTERISTIC;
  // Browser permission requires this call to originate from a user tap.
  device = await navigator.bluetooth.requestDevice({ acceptAllDevices: true, optionalServices: [service] });
  const server = await device.gatt.connect();
  const primary = await server.getPrimaryService(service);
  characteristic = await primary.getCharacteristic(writer);
  if (!characteristic.properties.write && !characteristic.properties.writeWithoutResponse) {
    throw new Error('ویژگی انتخاب‌شده قابلیت نوشتن ندارد.');
  }
  localStorage.setItem('onlinePackingPrinter', JSON.stringify({ service, writer }));
  return device.name || 'چاپگر';
}

function canvasFor(carton, kind) {
  const canvas = document.createElement('canvas');
  canvas.width = 384;
  const address = carton.address || {};
  const fields = [address.name, address.phone, `${address.state || ''} ${address.city || ''}`,
    address.text, `کد پستی: ${address.postal_code || ''}`];
  let ctx = canvas.getContext('2d');
  ctx.font = '20px sans-serif';
  let estimatedY = 167;
  if (kind === 'address') fields.forEach(value => {
    let line = '';
    String(value || '').split(/\s+/).forEach(word => {
      const next = line ? `${line} ${word}` : word;
      if (ctx.measureText(next).width > 355 && line) { estimatedY += 31; line = word; }
      else line = next;
    });
    estimatedY += 37;
  });
  canvas.height = kind === 'address' ? Math.max(560, estimatedY + 145) : 400;
  ctx = canvas.getContext('2d');
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#000';
  ctx.textAlign = 'center';
  ctx.direction = 'rtl';
  ctx.font = 'bold 31px sans-serif';
  ctx.fillText(kind === 'address' ? 'آدرس گیرنده' : 'شناسه کارتن', 192, 45);
  ctx.font = 'bold 26px sans-serif';
  ctx.fillText(`سفارش ${carton.order_code}`, 192, 88);
  ctx.fillText(`کارتن ${carton.number} ـ سایز ${carton.size}`, 192, 124);
  if (kind === 'address') {
    ctx.font = '20px sans-serif';
    let y = 167;
    fields.forEach(value => {
      const words = String(value || '').split(/\s+/);
      let line = '';
      words.forEach(word => {
        const next = line ? `${line} ${word}` : word;
        if (ctx.measureText(next).width > 355 && line) {
          ctx.fillText(line, 192, y); y += 31; line = word;
        } else line = next;
      });
      ctx.fillText(line, 192, y); y += 37;
    });
  }
  const barcodeCanvas = document.createElement('canvas');
  JsBarcode(barcodeCanvas, carton.token, { format: 'CODE128', displayValue: false,
    width: 2, height: 85, margin: 0, background: '#fff', lineColor: '#000' });
  const barcodeY = canvas.height - 138;
  ctx.drawImage(barcodeCanvas, 18, barcodeY, 348, 85);
  ctx.direction = 'ltr';
  ctx.font = '18px monospace';
  ctx.fillText(carton.token, 192, canvas.height - 25);
  return canvas;
}

function escposRaster(canvas) {
  const ctx = canvas.getContext('2d');
  const rgba = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
  const bytesPerRow = Math.ceil(canvas.width / 8);
  const image = new Uint8Array(bytesPerRow * canvas.height);
  for (let y = 0; y < canvas.height; y += 1) {
    for (let x = 0; x < canvas.width; x += 1) {
      const i = (y * canvas.width + x) * 4;
      if ((rgba[i] + rgba[i + 1] + rgba[i + 2]) / 3 < 150 && rgba[i + 3] > 128) {
        image[y * bytesPerRow + (x >> 3)] |= 0x80 >> (x & 7);
      }
    }
  }
  const payload = new Uint8Array(10 + image.length + 5);
  // ESC @ initializes; GS v 0 emits the raster with 16-bit width and height.
  payload.set([0x1b, 0x40, 0x1d, 0x76, 0x30, 0,
    bytesPerRow & 255, bytesPerRow >> 8, canvas.height & 255, canvas.height >> 8]);
  payload.set(image, 10);
  payload.set([0x1b, 0x64, 3, 0x0a], 10 + image.length);
  return payload;
}

export async function printCarton(carton, kind) {
  if (!printerConnected()) throw new Error('ابتدا چاپگر را وصل کنید.');
  if (kind === 'address' && !carton.address_ready) throw new Error('کارتن هنوز آمادهٔ چاپ آدرس نیست.');
  const bytes = escposRaster(canvasFor(carton, kind));
  // Conservative 20-byte writes work on BLE printers with the minimum MTU.
  for (let offset = 0; offset < bytes.length; offset += 20) {
    const chunk = bytes.slice(offset, offset + 20);
    if (characteristic.properties.writeWithoutResponse && characteristic.writeValueWithoutResponse) {
      await characteristic.writeValueWithoutResponse(chunk);
    } else {
      await characteristic.writeValue(chunk);
    }
  }
}
